import { Button, Card, CardContent } from '@material-ui/core';
import React from 'react';
import { generateUniqueKeyWithNoPrefix } from '../../../../helpers';
import { HttpErrorProps } from '../../../../hooks/useHttpError';
import Page from '../../../page/page';
import PageHeader from '../../../page/pageHeader';
import { GenericError } from '../../generic/genericError';

export interface PageErrorProps extends HttpErrorProps {
  title?: string;
  actions?: MainAction[];
}

export interface MainAction {
  label: string;
  onClick: () => void;
  default?: boolean;
}

export const PageError: React.FC<PageErrorProps> = ({ title, actions, ...props }) => {
  return (
    <>
      {props.errorCode !== undefined ? (
        <Page>
          <PageHeader title={title ?? ''}>
            {actions &&
              actions.map((action: MainAction) => {
                return (
                  <Button
                    key={generateUniqueKeyWithNoPrefix()}
                    size="small"
                    color="primary"
                    variant={action.default ? 'contained' : 'text'}
                    onClick={action.onClick}
                  >
                    {action.label}
                  </Button>
                );
              })}
          </PageHeader>
          <Card>
            <CardContent>
              <GenericError errorCode={props.errorCode} onRefresh={props.onRefresh} />
            </CardContent>
          </Card>
        </Page>
      ) : (
        <>{props.children}</>
      )}
    </>
  );
};
